/* eslint-disable */
import { camelCase } from 'voca';

type SnakeToCamelCaseFunction = {
  <T>(obj: Record<any, any>): T;
  (text: string): string;
};

const isObject = (obj: Record<any, any>) => (
  obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function'
);

const isString = (text: unknown) => typeof text === 'string'; 

export const snakeToCamelCase: SnakeToCamelCaseFunction = (value: any) => {
  if (typeof value === 'string') {
    return camelCase(value);
  }
  if (isObject(value)) {
    return Object.entries(value).reduce((accumulator, [key]) => {
      accumulator[camelCase(key)] = isString(value[key]) ? value[key] : snakeToCamelCase(value[key]);
      return accumulator;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map((item) => isString(item) ? item : snakeToCamelCase(item));
  }
  return value;
};
